import React from "react";
import Aside from "../Components/Aside";
import Header from "../Components/Header";
import Home from "../Components/Home";
import About from "../Components/About";
import Skills from "../Components/Skills";
import FrontProjects from "../Components/FrontProjects";
import BackProjects from "../Components/BackProjects";
import Contact from "../Components/Contact";
import Footer from "../Components/Footer";

export default function HomePage() {

  return (
    <>
    <Header />
    <Aside />
    <Home />
    <About />
    <Skills />
    <FrontProjects />
    <BackProjects />
    <Contact />
    <Footer />
    </>
  )
}